import { ROUTE_PATH } from './consts';

export const createEditPersonnelLink = profileId =>
  ROUTE_PATH.replace(':personalityId', profileId);
